<template>
    <section class=" font-poppins">
        <TheHeader/>

        <div class=" pt-32 md:pt-22 pb-5" >
            <p class="text-center font-bold text-blue-600 mb-2">TERMS AND POLICY</p>
            <div class="w-1/2 m-auto lg:w-full privacy p-3 leading-7" style="overflow:auto; height:25rem">
                <h2 class="font-bold">INTRODUCTION</h2> 
<p>We are CarryGO Logistech Nig. Ltd, a company registered under the Laws of the Federal 
Republic of Nigeria. We are into the business of transportation, logistics and haulage services. 
CarryGO is a place where logistics/transportation meets technology.</p> <br>
<h2 class="font-bold">ABOUT CARRYGO</h2>
<p>CarryGO is poised to carry out the business of transportation services (including air and sea), 
courier service for door-to-door deliveries, land transportation services; truck haulage and similar 
businesses with utmost distinct professionalism, excellence and speed. We deliver in style, class 
and utmost professionalism.</p> <br>
<h2 class="font-bold">CarryGO TERMS AND CONDITIONS</h2>
<p>By accepting the following terms and conditions you the customer agree to all terms and 
conditions without exception. The Terms of Use stated herein (collectively, the “Terms of Use” or 
this “Agreement”) constitute a tripartite agreement between you, the CG Carriers (CarryGO riders) 
and CarryGO Logistech Nig. Ltd (the “Company”). In order to use the service defined below, you 
must agree to the Terms of Use that are set out below. The Company reserves the right to modify, 
vary and change the Terms of Use or its policies relating to the service at any time as it deems 
fit. Such modifications, variations and or changes to the Terms of Use or its policies relating to 
the service shall be effective upon the posting of an updated version at CarryGO. You agree that 
it shall be your responsibility to review the Terms of Use regularly whereupon the continued use 
of the service after any such changes, whether or not reviewed by you, shall constitute your 
consent and acceptance to such changes.
Users are therefore advised to read the Terms of Use carefully prior to registering with the 
CarryGO App or making use of any of its services. Accepting the Terms of Use is done by clicking 
on the "Accept" button which binds the user to CarryGO Terms of Use.
The right to use the CGA and its services therein is availed to users conditionally, consequent 
upon acceptance of our Terms and conditions and instructions as stated in the Terms of Use and 
Privacy Policy. </p><br>
<h2 class="font-bold">DEFINITIONS</h2>
<p>In this Terms of Use, the following words shall be given the meaning intended:</p>
<li> CarryGO Logistech Nig. Ltd ('CarryGo'): is a company registered under the Laws of the 
Federal Republic of Nigeria.</li>
<li> Consignment/Parcel: means an item/good(s) intended to be picked up and/or delivered 
at a stated address by CarryGO for a customer</li>
<li> Aged Consignment: means a parcel no longer in the condition in which it was received 
by CarryGO, or which has become a health and safety risk.</li>
<li> Out of Gauge: means a parcel that exceeds the weight and/or type of good(s) allowed to 
be carried by CarryGo delivery service.</li>
<li> Prohibited Item: means item/good(s) prohibited by CarryGO, or/and is termed 
'contraband' by the laws of the Federal Republic of Nigeria </li>
<li> Purchased: means when you accept the Service Order.</li> 
<li> Damage: means any loss of, or damage to, a parcel </li>
<li> Pick-Up Point: means the address or location where item/good(s) are picked up by the 
CG Carrier. </li>
<li> Delivery Point: means the address or location where the item/good(s) will be delivered 
to by the CG Carrier.</li>
<li> Service: mean any of the four services provided in the app which are: Buy for me, Haulage, 
send a package and book a ride. </li>
<li> Delivery Service Operators (DSP): means registered partners, operators to the 
CarryGO App and independent contract Carriers of CarryGO, also known as third party 
riders.</li>
<li> Higher Purchase (HP) Carriers: They are also independent contract Carriers of CarryGO, 
also known as 3rd party Carriers.</li>
<li> CarryGO App: the software application that provides for our Tech Platform Service (TPS)
where our services are made available to users in the tech space.</li>
<li> User: a person or group of persons (like a company, an organization,...) that intend to 
access our services and have accepted our Terms of Service.</li>
<li> Tech Platform Service (TPS): the foundation for running our business services 
application. It describes the concept of the entire service of the app and web provided.</li>
<li> CG Carrier: can respectively or collectively mean CarryGO employed carrier, 
Independent Service Operators or Hire Purchase Carriers</li>
<li> User: Anyone who uses any of the services on the TPS</li>
<br>
<h2 class="font-bold">HOW TO REGISTER</h2>
<p>Access to TPS to gain connection with CG Carriers and DSP's is granted only after you may 
have successfully registered an account on the CarryGO App. Details such as names, emails, 
phone numbers, occupation and biometrics (optional) shall be required during registration.
You will be required to undergo a verification process to confirm the authenticity of your details 
provided (as aforementioned)
CarryGO Logis-Tech reserves the right to display Information's such as; reviews, ratings, 
feedback etc as provided by you on the CarryGO app TPS. You agree and accept that all 
information provided by you during registration on the TPS is completely true and accurate, and 
also that you shall promptly update CarryGo Logis-Tech in writing, of any change or changes to 
the above information, in not less than 48 hours from the day of such change, and such change 
shall be effected in you registration details.
If you provide any information that is false, inaccurate, incomplete and misleading or if CarryGO 
has reasonable basis to suspect such information's to be false, inaccurate, incomplete or 
misleading, CarryGO reserves the right to suspend or terminate your account, refuse any or all 
current or future use of the TPS (or any part of it thereof).
The CarryGO App provides the following services that are accessible to people eligible by the 
law to enter contracts:</p>
<li> Send a Package: this service connects Users with CG Carriers to initiate the carriage of 
legally permitted consignments/parcels, from one point known as the 'Pick-up location' to 
another known as the 'delivery location'. This service also enables scheduled deliveries at 
best users' convenient times. Note: deliveries can also be done interstate.</li>
<li> Book a Ride: allows passengers to hail a ride with our CarryGo App at a fee determined 
by CarryGO. CarryGO employ its Carriers and as well hires independent contract drivers 
to transport its customers from one location to another.</li>
<li> Buy For Me : is an errand service where carriers can buy specific commodities for 
customer from non-registered vendors and have them delivered. The 'items' here includes 
but are not limited to food and beverages, and as many items as the CarryGO team may 
allow from time to time. Note: this service can only be funded by money in the Customer's 
app wallet. Physical cash are not allowed to fund this service.</li>
<li> Haulage: this service caters for the transport of heavy-duty consignments from one place 
to another. We operate both within a state and interstate.
Upon completion of any of our services listed on our CarryGo TPS (as listed above), users will be 
notified on the platform. Note: that CarryGO reserves the right to add, modify, upgrade, extend, 
withdraw or alienate any of its services listed above at any point in time as often as it deems 
necessary.</li>
<br>
<h2 class="font-bold">TERMS OF USE OF THE SERVICE</h2>
<h3 class="font-semibold">CUSTOMER'S OBLIGATIONS</h3>
<p>You agree: 
1. to provide sufficient description concerning items/services you intend to purchase/request 
on the CarryGO App for a successful and accurate service order booking. <br>
2. To provide the Carrier undenied and reasonable access to your residential address, office, 
or any stated delivery point. The Recipient shall ensure that the premises are free of 
hazardous materials and do not in any way pose a risk to the health and safety of the 
Carrier. <br>
3. To provide CarryGO with such accurate information and materials as may be reasonably 
required to deliver the Service(s).<br>
4. Not to give our Carriers items that are illegal or contraband, or that are contrary to any law 
in force in the Federal Republic of Nigeria for delivery. Should a User do the contrary, 
CarryGO herein absorbs itself of any liability that may arise. The User shall be held liable 
for same, the Carrier shall not, carry: livestock; perishable food Items; liquids; perishable 
goods; gasses; pyrotechnics; arms; ammunition; corrosive; toxic; flammable; explosive; 
oxidizing or radioactive materials. In addition, the carrier shall not carry any item/good(s) 
prohibited by the laws of the Land. CarryGO and its Carriers reserves the right to refuse 
any parcel which are not handed over to its care by the owner or received by its owner 
which are neither the property of person with whom the parcel was picked up from, or 
delivered to.<br>
5. All Consignments shall be accepted at the delivery point and that the recipient shall 
acknowledge receipt of the parcel which shall serve as conclusive evidence of the delivery. 
Unless specifically agreed otherwise, “working days” do not include Saturday, Sunday or 
public holidays. <br>
6. There shall be no refund or reduction of the agreed fee for delivery. <br>
7. Consignment weighing more than 3 Kilograms shall be subject to additional charges per <br>
kilogramme as determined by CarryGO, therefore Carrier reserves the right to refuse pick-up or delivery of Consignments weighing over the set limit except access charges are paid.
8. You are obligated to disclose the nature of the Consignment to be delivered to the Carrier. <br>
Food items such as palm oil, crayfish, locus beans and such as is stated by CarryGO is 
prohibited from being delivered via our delivery service. Items such as passport, bank 
cheques, money or any material pertaining to cash transactions are also prohibited from 
delivery on this platform. <br>
9. You shall Indicate delivery item/good(s) that are valuable and/or of a delicate nature to 
CarryGO Carrier at the Pick-up location. <br>
10. You are to maintain the orders according to the outlined product categories, fully 
understand each category description, and strictly abide to restrictions placed on the 
different category of products.<br>
11. You are to wrap up and put in safe condition item/good(s) to be delivered so as to prevent 
destruction or damage to Consignment, the Carrier or delivery equipment/machinery. <br>
12. You are to put in carton and bubble-wraps electronics set out for delivery, so as to avoid 
damages, and pay DSP/Rider upfront for such delivery. Failure to do so may leave the 
Carrier with no choice than to reject such delivery contract.<br>
13. You are to pay our Carriers promptly, without delay. <br>
14. You are to report any damaged/missing/lost item/good(s) to our support team within 5 
hours of delivery. CarryGO parcels shall not accept full liability item/good(s) that is 
damaged or lost. <br>
15. To engage CarryGO's Customers with competency and and carry out its transportation or 
logistics business with utmost professionalism. <br>
16. To verify consignment/parcel assigned to them for delivery and report any suspicious 
parcel or person(s) to the appropriate authority. Any User found to be transporting illegal 
items or items prohibited by the laws of the Federal Republic of Nigeria shall have their 
account with CarryGO suspended or terminated.<br>
17. Following, should any Consignment/Parcel of an illegal, dangerous or prohibited nature 
be found with a Carrier, such Carrier shall bear the full liability for carrying such substance. 
18. Deliver our customers or their Consignment in style, excellence and utmost 
professionalism. <br>
19. Adherence to Rules: Rule stated herein, in their terms of contract with the company, and 
rules and guidelines that impliedly apply to them due to the nature of business.<br>
20. Remittance: who fails remit the Company's percentage shall be blocked from the app, and 
legal actions shall be instituted against such rider. <br>
21. CarryGO is under no obligation to provide equipment(s) or labor for the pick-up or delivery 
of any parcel assigned to it for delivery. <br>
22. Any consignment (or part of a consignment) requiring any equipment for loading and/or 
unloading shall be undertaken by CarryGo on the condition that such equipment shall be 
made available at the Pick-up Point and the Delivery Point within one (1) hour of the arrival 
of Carrier, at no cost to CarryGo. Where such equipment is not available, should the 
Carrier offer to aid in the loading or unloading of the consignment (or part of the 
Consignment) CarryGO shall not be liable to the Customer for any damage caused 
(however it may be caused). This includes damages that occurred due to our Carrier 
negligence (CarryGO remains not liable for such damages). This is because most of our 
Carriers are independent contract carriers and are employed to simply deliver goods from 
a pick-up location to a delivery location.</p> <br>
<h2 class="font-bold">COLLECTION AND DELIVERY </h2>
<p>Collection and delivery of Consignments shall be done during working hours. Should our Carrier 
be unable to deliver the item/good(s) at the delivery location due to his: 
(I) inability to locate the delivery location or (II) find a person he reasonable believes to be capable 
of receiving the said item/good(s). </p>
<li> In the event of paragraph (I), he shall either contact the receiver to get further instruction, 
and if unable to get through to the receiver, he shall deliver same to a nearby known and 
safe address (alternate address), obtain a delivery receipt and thereafter inform the 
receiver of the delivery OR he shall return the Consignment to a carryGo designated 
address.</li>
<li> In the event of paragraph (II), he shall obtain all reasonable details required to identify 
the person with whom the Consignment was handed over to, as well as a delivery receipt. 
He shall furnish the Recipient with such details.</li>
<p>NOTE: The decision to either leave the Consignment at a 'known and safe address' or with a 
'reasonable person' or 'to return to the pick-up point shall be made at the point of pick up by the 
Customer. And in the event that the Parcel is finally returned to the Pick-up Point, the Customer 
shall be liable to pay a 100% of the initial delivery fee due to time and resources wasted.</p>
<li> (III) In the event that our Carrier is unable to deliver the goods or drop same at a 
reasonable place or with a reasonable person, such Consignment shall be returned to 
CarryGo designated office. And If the Recipient does not contact us to arrange an 
alternative delivery within 7 days, the Consignment shall be returned to the 
Customer/Pick-Up person at cost. Such cost shall not be less than a 100% of the delivery 
fee. And such cost shall be discharged before handed over to the Customer.</li>
<li> Should the Consignment exceed 7 (seven) days at the CarryGO designated office, daily 
demurrage fee shall apply.</li>
<li> If our Carriers considers that the Consignment to be dangerous, damaged or hazardous, 
they reserve the right to refuse delivery and/or dispose of the damaged parcel immediately. </li>
<br>
<h2 class="font-bold">LIABILITY</h2>
<p>CarryGO being a reputable company undertakes to professionally and excellently carry out its 
delivery service with the appropriate level of skill and care, in conjunction with its Carriers. In view 
of the above, CarryGO only employs or allows in its service men and women who have shown 
themselves to be good and reasonable Carriers. <br>
Following, Carriers shall be responsible to keep in good condition every person or group of 
persons, consignment or parcel in their care for transport purposes or delivery. Carrier shall 
therefore bear full responsibility for any inconvenience or harm caused to its users and/or damage 
to its consignment/ parcels due to their negligence or recklessness. Put differently, Carriers shall 
bear full liability for any inconvenience to Users or their Consignment in their care. More so, 
CarryGO shall not be liable for the conducts, acts or omissions of its Independent Contract 
Carriers. <br>
Where damages occur that are not due to Carriers recklessness or negligence, the liability of all 
parties shall be ascertained and determined based on the peculiarity of the case. 
CarryGO absorbs itself from any liability arising from damage to Consignment/Parcel in its care 
termed as 'acts of God', natural hazards such as earthquake, flooding, tsunami, etc. The degree 
of CarryGO liability (with regards to its employed Carriers) for inconveniences or damage caused 
to its Users or their Consignment in the event of civil unrest, disorder, disturbance or social unrest 
shall be limited to the barest minimum. <br>
Under any circumstances where there are material discrepancies between the declared 
dimensions and weights of parcel and the actual dimensions and weights; CarryGO shall not be 
liable in any regards. Illegal consignment/parcel and such that are prohibited by the Laws of the 
Federal Republic of Nigeria are not allowed in our services. Should any Consignment be 
discovered to be fall under any of this nature, CarryGO shall have the right to take appropriate 
lawful actions against you.<br>
Note: CarryGO shalll not undertake full liability for damaged to fragile, and valuable 
Consignment/Parcel or the loss of same, unless the nature, and value of such Parcel was at the 
point of pick up stated and its corresponding fee paid.
you agree that CarryGo LogisTech has no control over the items or packages provided to you by 
vendors and therefore, shall not incur any liability of such items. </p><br>
<h2 class="font-bold">BOOKINGS</h2>
<p>All Bookings and/rebookings shall be done via the CarryGO app, and such bookings can only be 
done 'one per time'. If your booking request cannot be completed due to reasons, you shall be 
notified by the CarryGO team. <br>
Note:the acceptance of all bookings is dependent on the availability of Carriers in your 
geographical location. Should you decide to reschedule your booking request, you shall cancel 
your current request stating reasons why. <br>
Par adventure you choose to reschedule a request on the CarryGo App, you shall cancel the 
current transactions on the CarryGo App at a later time, you shall cancel the current request, 
booking or transaction on the CarryGo App (if already actioned) and action a new request on the 
platform, at your convenience. <br>
If a request actioned by you on the CarryGo App cannot be completed, CarryGo LogisTech shall 
inform you accordingly on the CarryGo App.</p>
<br>
<h2 class="font-bold">PAYMENT</h2>
<p>You may choose to pay for our services:</p>
I) by cash and where available, <br>
ii) by using CarryGO Credits (your cash wallet with CarryGO) as detailed below: <br>
<li> Payments shall be made in full upon the completion of service, and such payment is non-refundable. </li>
<li> Based on the services requested, payments can either be paid before or after completion 
of service.</li>
<li> You may purchase credits (“CarryGO Credits”) which shall be used to pay for the services 
you requested on our TSP. CarryGO Credits shall be purchased through the methods 
made available in the application from time to time. </li>
<li> Selecting a particular payment method means you are agreeing to the terms of service of 
the Company's processing partners and your financial institution. You will bear all fees 
that may be charged by such processing partners and/or your financial institution (if any) 
for the payment method you have selected. </li>
<li> CarryGo credits are not redeemable for cash neither are they refundable. They cannot be 
resold, exchanged or transferred for value. You will not receive interest or other earnings 
on your CarryGO Credits. The Company may however receive interest on amounts that 
the Company holds on your behalf. You agree to assign your rights to the Company for 
any interest derived from your CarryGO Credits.</li>
<li> You shall ensure that you have sufficient CarryGO Credits to pay for the 
transportation/delivery services. Should you have insufficient credit balance to pay for the 
transportation services, you may purchase additional CarryGO Credits to complete your 
payment for the transportation/delivery services. You may check your CarryGO Credits 
balance in the application. </li>
<br>
<h2 class="font-bold">FEEDBACK</h2>
<p>CarryGO values your feedback. Our app therefore enables rating, reviews and feedback from 
users regarding DSP's and CG Carriers. CarryGO makes use of feed backs and reviews for 
quality control purposes to facilitate improvement in the quality of services rendered.</p>
<br>
<h2 class="font-bold">TAXES</h2>
<p>This Agreement shall be subject to all prevailing statutory taxes, duties, fees, charges and/or 
costs, as may be in force in Nigeria however denominated. You further agree to do the needful 
required by the relevant laws to enable, assist and/or defend the Company to claim or verify any 
input tax credit, set off, rebate or refund in respect of any taxes paid or payable in connection with 
the service supplied under this Agreement. </p> <br>
<h2 class="font-bold">LICENCE GRANT & RESTRICTS</h2>
<p>The Company and its licensors, where applicable, hereby grants you a revocable, non-exclusive, 
non-transferable, non-assignable, personal, limited license to use the application and/or the 
software, for your own personal use, not for commercial purposes, subject to the Terms of Use 
herein. All rights not expressly granted to you are reserved by the Company and its licensors. </p>
<p>a) You shall not license, sub-license, sell, resell, transfer, assign, distribute or otherwise 
commercially exploit or make available to any third party the application and/or the software in 
any way; modify or make derivative works based on the application and/or the software; create 
internet “links” to the application or “frame” or “mirror” the software on any other server or wireless 
or internet-based device; reverse engineer or access the software in order to; <br>
▪ I) Build a competitive product or service; <br>
▪ II) Build a product using similar ideas, features, functions or graphics of the application 
and/or the Software, or; <br>
▪ III) Copy any ideas, features, functions or graphics of the Application and/or the Software, 
launch an automated program or script, including, but not limited to, web spiders, web 
crawlers, web robots, web ants, web indexers, bots, viruses or worms, or any program 
which may make multiple server requests per second, or unduly burdens or hinders the 
operation and/or performance of the Application and/or the Software, use any robot, spider, 
site search/retrieval application, or other manual or automatic device or process to retrieve, 
index, “data mine”, or in any way reproduce or circumvent the navigational structure or 
presentation of the Service or its contents; post, distribute or reproduce in any way any 
copyrighted material, trademarks, or other proprietary information without obtaining the 
prior consent of the owner of such proprietary rights, remove any copyright, trademark or 
other proprietary rights notices contained in the Service. <br>
b)You may use the Software and/or the Application only for your personal use and not for 
commercial purposes and shall not use the Software and/or the Application to: send spam or 
otherwise duplicative or unsolicited messages; send or store infringing, obscene, threatening, 
libelous, or otherwise unlawful or tortious material, including but not limited to materials harmful 
to children or violative of third party privacy rights; send material containing software viruses, 
worms, trojan horses or other harmful computer code, files, scripts, agents or programs; interfere 
with or disrupt the integrity or performance of the Software and/or the Application or the data 
contained therein; attempt to gain unauthorized access to the Software and/or the Application or 
its related systems or networks; or Impersonate any person or entity or otherwise misrepresent 
your affiliation with a person or entity to abstain from any conduct that could possibly damage the 
Company's reputation or amount to being disreputable. </p>
<br>
<h2 class="font-bold">INTELLECTUAL PROPERTY OWNERSHIP</h2>
<p>▪ The Company and its licensors, where applicable, shall own all right, title and interest, 
including all related intellectual property rights, in and to the Software and/or the 
Application and by extension, the Service and any suggestions, ideas, enhancement 
requests, feedback, recommendations or other information provided by you or any other 
party relating to the Service. <br>
▪ The Terms of Use do not constitute a sale agreement and do not convey to you any rights 
of ownership in or related to the Service, the Software and/or the Application, or any 
intellectual property rights owned by the Company and/or its licensors. The Company's 
name, the Company's logo, the Service, the Software and/or the Application and the third-party transportation providers' logos and the product names associated with the Software 
and/or the Application are trademarks of the Company or third parties, and no right or 
license is granted to use them. <br>
▪ For the avoidance of doubt, the term the Software and the Application herein shall include 
its respective components, processes and design in its entirety.</p>
<br>
<h2 class="font-bold">PRIVACY POLICY</h2>
<p>▪ The CarryGO App is built by CarryGO Logistech Nig. Ltd. This SERVICE is provided by 
CarryGO Logistech Nig. Ltd at no cost and is intended for use. <br>
▪ This page is used to inform visitors regarding our policies with the collection, use, and 
disclosure of Personal Information deemed necessary.<br>
▪ If you choose to use our Service, then you agree to the collection and use of information 
in relation to this policy. The Personal Information that we collect is used for providing and 
improving the Service. Be assured that we shall not share your information with anyone 
only as described in this Privacy Policy.<br>
▪ The terms used in this Privacy Policy have the same meanings as in our Terms and 
Conditions, which is accessible at CarryGO unless otherwise defined in this Privacy Policy.</p><br>
<h2 class="font-bold">LOCATION TRACKING</h2>
<p>▪ To participate as a CG Carrier, you must permit the CG Carrier App Services to access 
location through the ' permission system' in your mobile operating system (“Platform”) or 
browser. The precise location of your device can be detected when the CG Carrier App is 
running in the foreground or background of your device. We may also derive your 
approximate location from your IP address. We use your location information to verify that 
you are present in your preferred region or city when you begin or engage in a delivery 
through the CarryGO Carrier App, connect you with delivery opportunities in your zone, 
and track the progress and completion of your deliveries. You can enable the location 
tracking feature through the settings on your device or Platform or when prompted by the 
CG Carrie App (mobile app). If you choose to disable the location feature through the 
settings on your device or Platform, the CG Carrier shall be unable to get a precise location 
information from your device, which shall prevent you from being able to embark on a trip 
or receive delivery opportunities in your area via the CarryGO app.</p>
<br>
<h2 class="font-bold">INFORMATION COLLECTION AND USE</h2>
<p>For a better experience, while using our Service, we may require you to provide us with certain 
personal information. The information that we request will be retained by us and used as 
described in this privacy policy. The app does use third party services that may collect information 
used to identify you.</p><br>
<h2 class="font-bold">LOG DATA</h2>
<p>This app collates data and information (through a third-party products) on your phone called Log 
Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, 
device name, operating system version, the configuration of the app when utilizing our Service, 
the time and date of your use of the Service, and other statistics. </p><br>
<h2 class="font-bold">COOKIES</h2>
<p>Cookies are files with a small amount of data that are commonly used as anonymous unique 
identifiers. These are sent to your browser from the websites that you visit and are stored on your 
device's internal memory. This Service does not use these “cookies” explicitly. However, the app 
may use third party code and libraries that use “cookies” to collect information and improve their 
services. You have the option to either accept or refuse these cookies and know when a cookie 
is being sent to your device. Refusal to accept any cookie may affect your ability to use some 
portions of this Service.</p><br>
<h2 class="font-bold">SERVICE PROVIDERS</h2>
<p>Third-party companies and individuals may be employed by CarryGO for the following reasons:</p>
<p>▪ To facilitate our Service; <br>
▪ To provide the Service on our behalf;<br>
▪ To perform Service-related services; or<br>
▪ To assist us in analyzing how our Service is used.<br>
▪ Be informed that these third parties may have access to your personal information in order 
to perform tasks assigned to them on our behalf. However, they remain under obligation 
not to disclose or use your personal data for other purposes.</p><br>
<h2 class="font-bold">SECURITY</h2>
<p>▪ We value the trust you have placed in us and thus strive to secure your personal data 
through the use of commercially acceptable means. However, it is important to note that 
there is never a 100% security when using the internet, or method of electronic storage.</p> <br>
<h2 class="font-bold">LINKS TO OTHER SITES</h2>
<p>▪ This Service may contain links to other sites. If you click on a third-party link, you will be 
directed to that site. Note that these external sites are not operated by us. Therefore, we 
strongly advise you to review the Privacy Policy of these websites. We have no control 
over and assume no responsibility for the content, privacy policies, or practices of any 
third-party sites or services.</p>
 
<p class=" text-gray-500">&copy; This document is protected by applicable copyright laws and international treaties.</p>
            </div>
        </div>
        <div >

        <TheFooter/>
        </div>
    </section>
</template>

<script>
import TheHeader from '../layout/TheHeader.vue';
import TheFooter from '../layout/TheFooter.vue';
export default {
    components: {
        TheHeader,
        TheFooter,
    }
}
</script>

<style scoped>
.privacy {
    border-radius: 2rem;
    border: 3px solid royalblue;
}
</style>